import { cn } from "@/lib/cn";
import { Card } from "../Card";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface DetalleSkeletonProps {
  /**
   * 3 = detalle de solicitud (resumen 3 · contenido 6 · lateral 3, centrado en
   * `max-w-7xl`) · 2 = vista del autorizador (contenido 8 · lateral 4, ancho completo).
   */
  columnas?: 2 | 3;
}

/** Detalle de una entidad en carga: encabezado, pestañas, pares etiqueta-valor y columna lateral. */
export function DetalleSkeleton({ columnas = 2 }: DetalleSkeletonProps) {
  const tres = columnas === 3;
  return (
    <RegionCargando
      etiqueta="Cargando detalle…"
      className={tres ? "mx-auto max-w-7xl px-4 py-8 md:px-6" : "w-full px-4 py-6 md:px-6"}
    >
      <Encabezado />
      <div className="grid grid-cols-12 gap-4" aria-hidden="true">
        {tres && (
          <div className="order-2 col-span-12 md:col-span-4 lg:order-1 lg:col-span-3">
            <TarjetaLista filas={5} />
          </div>
        )}
        <div className={cn("col-span-12", tres ? "order-1 md:col-span-8 lg:order-2 lg:col-span-6" : "lg:col-span-8")}>
          <Card>
            <div className="mb-5 flex gap-4 border-b border-border pb-3">
              {[72, 96, 64, 84].map((w, i) => (
                <Skeleton key={i} height={14} width={w} />
              ))}
            </div>
            <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
              {Array.from({ length: 8 }, (_, i) => (
                <div key={i} className="flex flex-col gap-1.5">
                  <Skeleton height={10} width="35%" />
                  <Skeleton height={14} width={i % 3 === 0 ? "80%" : "60%"} />
                </div>
              ))}
            </div>
          </Card>
        </div>
        <div className={cn("col-span-12", tres ? "order-3 lg:col-span-3" : "lg:col-span-4")}>
          <TarjetaLista filas={4} />
        </div>
      </div>
    </RegionCargando>
  );
}

function Encabezado() {
  return (
    <div className="mb-6 flex flex-col gap-2" aria-hidden="true">
      <Skeleton height={10} width={200} />
      <div className="flex flex-wrap items-center gap-3">
        <Skeleton height={26} width={240} />
        <Skeleton height={22} width={110} className="rounded-full" />
      </div>
      <Skeleton height={14} width={360} className="max-w-full" />
    </div>
  );
}

function TarjetaLista({ filas }: { filas: number }) {
  return (
    <Card padding="md">
      <Skeleton height={14} width="45%" />
      <div className="mt-4 flex flex-col gap-3">
        {Array.from({ length: filas }, (_, i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton height={24} width={24} circle className="shrink-0" />
            <Skeleton height={12} width={i % 2 === 0 ? "75%" : "55%"} />
          </div>
        ))}
      </div>
    </Card>
  );
}
